import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { cn } from '@/lib/utils';
import { convertLocalTimezone } from '@/utils/dateUtils';
import React from "react";
import type { CallsDetailOverviewWidgetData } from "./CallsDetailOverviewWidget";
import Timeline from "./Timeline";
import { useDashboard } from '@/contexts/DashboardContext';

interface CallDetailsModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  callDetail: CallsDetailOverviewWidgetData;
}

const CallDetailsModal: React.FC<CallDetailsModalProps> = ({
  open,
  onOpenChange,
  callDetail,
}) => {
  const { theme } = useDashboard();
  const isOutbound = callDetail?.direction === "Outbound";

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className={cn(
        "sm:max-w-[600px] max-h-[700px] flex flex-col",
        theme === 'dark' ? "bg-[#0C3451] text-white" : "bg-white"
      )}>
        <DialogHeader className="flex-shrink-0">
          <DialogTitle className={cn(
            "text-xl font-bold",
            theme === 'dark' ? "text-white" : "text-gray-900"
          )}>
            Call Details
          </DialogTitle>
        </DialogHeader>
        <div className="flex-1 overflow-y-auto">
          <div className="grid grid-cols-2 gap-6 mt-4">
            <div>
              <div className="text-sm text-gray-500 dark:text-muted-foreground font-medium">Customer</div>
              <div className={cn(
                "font-semibold text-lg",
                theme === 'dark' ? "text-white" : "text-gray-900"
              )}>{callDetail?.customerName}</div>

              <div className="text-sm text-gray-500 dark:text-muted-foreground font-medium mt-4">{isOutbound ? "Phone" : "Agent"}</div>
              <div className={cn(
                "font-semibold text-lg",
                theme === 'dark' ? "text-white" : "text-gray-900"
              )}>{isOutbound ? callDetail?.callee : callDetail?.huntedAgent}</div>

              <div className="text-sm text-gray-500 dark:text-muted-foreground font-medium mt-4">Date & Time</div>
              <div className={cn(
                "font-semibold",
                theme === 'dark' ? "text-white" : "text-gray-900"
              )}>{convertLocalTimezone(callDetail?.startTime)}</div>
            </div>

            <div>
              <div className="text-sm text-gray-500 dark:text-muted-foreground font-medium"> Organizer </div>
              <div className={cn(
                "font-semibold text-lg",
                theme === 'dark' ? "text-white" : "text-gray-900"
              )}>{callDetail?.caller}</div>

              <div className="text-sm text-gray-500 dark:text-muted-foreground font-medium mt-4">Queue</div>
              <div className={cn(
                "font-semibold text-lg",
                theme === 'dark' ? "text-white" : "text-gray-900"
              )}>{callDetail?.callQueue}</div>

              <div className="text-sm text-gray-500 dark:text-muted-foreground font-medium mt-4">Duration</div>
              <div className={cn(
                "font-semibold text-lg",
                theme === 'dark' ? "text-white" : "text-gray-900"
              )}>{callDetail?.callDuration}</div>

            </div>
          </div>
          <div className="mt-6 border border-gray-200 rounded-xl p-4">
            <div className="text-lg text-muted-foreground font-medium">Call Journey</div>
            <div className="mt-2">
              <Timeline callId={callDetail?.callId} />
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CallDetailsModal; 